<form (ngSubmit)="gerarQrCode()">

  <div class="ui-g">

    <div class="ui-g-12">
      <h1>Gerar PIX</h1>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12">
      <label for="conta">Conta:</label>
      <span id="conta" style="margin-left: 6px;">{{ licenca.contrato }}</span>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-fluid">
      <label for="valor">Valor:</label>
      <input pInputText id="valor" name="valor" [(ngModel)]="valor" maxlength="20" [pKeyFilter]="regExValor"
        [readonly]="depositoPix.id" onFocus="this.select();" style="margin-top: 5px;" #valorPix>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-fluid">
      <label for="historico">Histórico:</label>
      <input pInputText id="historico" name="historico" [(ngModel)]="depositoPix.historico"
        [readonly]="depositoPix.id" onFocus="this.select();" style="margin-top: 5px;">
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="depositoPix.qrCode">
      <label for="qrCode">QR CODE:</label>
      <div id="qrCode" [innerHtml]="depositoPix.qrCode"></div>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-fluid" *ngIf="depositoPix.copyPaste">
      <label for="copyPaste">PIX Copia e Cola:</label>
      <textarea pInputTextarea id="copyPaste" name="copyPaste" [rows]="5" readonly style="margin-top: 5px;"
        [(ngModel)]="depositoPix.copyPaste"></textarea>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="depositoPix.id">
      <label for="txid">TX ID:</label>
      <span id="txid" style="margin-left: 6px;">DEP{{ depositoPix.id }}</span>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="depositoPix.id">
      <label for="endToEndId">Autorização:</label>
      <span id="endToEndId" style="margin-left: 6px;">{{ depositoPix.endToEndId }}</span>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="depositoPix.id">
      <label for="contaOrigem">Conta Origem:</label>
      <span id="contaOrigem" style="margin-left: 6px;">{{ depositoPix.contaOrigem }}</span>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="depositoPix.user">
      <label for="user">Criado por:</label>
      <span id="user" style="margin-left: 6px;">{{ depositoPix.user }}</span>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="depositoPix.status">
      <label for="status">Status:</label>
      <span id="status" style="margin-left: 6px;">{{ depositoPix.status }}</span>
    </div>

    <div class="ui-g-12 ui-fluid" style="margin-top: 10px;" *ngIf="!depositoPix.id">
      <button pButton type="submit" label="Gerar PIX" icon="fas fa-qrcode" class="ui-button-primary"></button>
    </div>

    <div class="ui-g-12 ui-fluid" style="margin-top: 10px;" *ngIf="depositoPix.id">
      <button pButton label="Fechar" icon="pi pi-sign-out" class="ui-button-primary" (click)="fechar()"></button>
    </div>

  </div>

</form>


<p-blockUI [blocked]="blocked">
  <p-progressSpinner class="spinner-center">
  </p-progressSpinner>
</p-blockUI>
